export default __webpack_public_path__ + "static/media/Baby2.34456010.gif";